import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretSquareDown,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import AnnotationsModule from "highcharts/modules/annotations";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Typeahead } from "react-bootstrap-typeahead";

// keep default theme for now
// import DarkUnica from 'highcharts/themes/high-contrast-dark.js'
// DarkUnica(Highcharts)
import Boost from "highcharts/modules/boost";
AnnotationsModule(Highcharts);
Boost(Highcharts);

var US_LOCATION = "US";
var GLOBAL_LOCATION = "Global";
var SCALED_SUFFIX = "Scaled";
var US_LOCATION_SCALED = US_LOCATION + SCALED_SUFFIX;
var GLOBAL_LOCATION_SCALED = GLOBAL_LOCATION + SCALED_SUFFIX;
var DAILY_CHANGE_MODE = "dailyCounts"; // these are keys into the response from the server
var DAILY_CHANGE_ROLLING_MODE = "dailyCountsRolling";
var CUM_COUNT_MODE = "cumCounts";
var SORT_BY_AZ = "A-Z"; // these are displayed in the sorting dropdown as well
var SORT_BY_VALUE = "Value";

class ChartArea extends Component {
  state = {
    showLabelValues: true,
    scaleByPopulation: false,
    location: US_LOCATION,
    mode: DAILY_CHANGE_MODE,
    isLoading: false,
    regionFilter: new Set([]),
    sortBy: SORT_BY_VALUE,
  };

  constructor(props) {
    super(props);
    this.handleModeChange = this.handleModeChange.bind(this);
    this.handleScaleByPopulationChange = this.handleScaleByPopulationChange.bind(
      this
    );
    this.handleShowLabelValuesChange = this.handleShowLabelValuesChange.bind(
      this
    );
    this.handleSortByChange = this.handleSortByChange.bind(this);
    this.handleRegionFilterChange = this.handleRegionFilterChange.bind(this);
    this.turnOffLoading = this.turnOffLoading.bind(this);
    this.turnOnLoading = this.turnOnLoading.bind(this);
  }

  // _getLocationId(location, scaledByPopulation) {
  //   if (scaledByPopulation) {
  //     return location + SCALED_SUFFIX;
  //   } else {
  //     return location;
  //   }
  // }

  handleModeChange(val) {
    let tokens = val.split("_");
    if (tokens[0] !== this.state.location) {
      console.log("setting loading screen on");
      this.setState({ location: tokens[0], mode: tokens[1], isLoading: true });
    } else {
      this.setState({ location: tokens[0], mode: tokens[1] });
    }
  }

  handleScaleByPopulationChange(e) {
    if (e.target.checked !== this.state.scaleByPopulation) {
      this.setState({ scaleByPopulation: e.target.checked, isLoading: true });
    }
  }

  handleShowLabelValuesChange(e) {
    this.setState({ showLabelValues: e.target.checked });
  }

  handleSortByChange(val) {
    this.setState({ sortBy: val });
  }

  handleRegionFilterChange(s) {
    this.setState({ regionFilter: new Set(s) });
  }

  turnOffLoading() {
    this.setState({ isLoading: false });
  }

  turnOnLoading() {
    this.setState({ isLoading: true });
  }

  render() {
    document.title = "COVID Dashboard - Case Counts";
    let dataSourceStatement =
      "Counts up to March 10, 2023 based on data from the COVID-19 Data Repository by " +
      "the Center for Systems Science and Engineering (CSSE) at Johns Hopkins University. " +
      "Population estimates based on data from the US Census and WorldBank.";
    return (
      <div>
        <ChartHeader
          handleChange={this.handleModeChange}
          mode={this.state.mode}
          location={this.state.location}
          scaleByPopulation={this.state.scaleByPopulation}
        ></ChartHeader>
        <Row className="justify-content-center" id="region-filter-row">
          <Col md="6" sm="9" xs="12">
            <RegionFilter
              handleChange={this.handleRegionFilterChange}
              location={this.state.location}
              value={this.state.regionFilter}
            />
          </Col>
          <Col xs="12" sm="1">
            <SortByDropdown
              handleChange={this.handleSortByChange}
              value={this.state.sortBy}
            ></SortByDropdown>
          </Col>
        </Row>
        <Row className="justify-content-center" id="switch-row">
          <Col xs="12" sm="10" md="7">
            <LabelValueSwitch
              handleChange={this.handleShowLabelValuesChange}
              mode={this.state.mode}
              value={this.state.showLabelValues}
            />
            <ScaleByPopulationSwitch
              handleChange={this.handleScaleByPopulationChange}
              value={this.state.scaleByPopulation}
            />
          </Col>
        </Row>
        <Chart
          location={this.state.location}
          mode={this.state.mode}
          scaleByPopulation={this.state.scaleByPopulation}
          isLoading={this.state.isLoading}
          regionFilter={this.state.regionFilter}
          showLabelValues={this.state.showLabelValues}
          sortBy={this.state.sortBy}
          turnOffLoading={this.turnOffLoading}
          turnOnLoading={this.turnOnLoading}
        />
        <Row id="data-source-statement">
          <small className="text-muted">{dataSourceStatement}</small>
        </Row>
      </div>
    );
  }
}

class SortByDropdown extends Component {
  render() {
    return (
      <Dropdown
        onSelect={this.props.handleChange}
        alignRight={true}
        id="sort-by-dropdown"
      >
        <Dropdown.Toggle id="sort-by-dropdown">
          Sort by {this.props.value}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item eventKey={SORT_BY_AZ}>{SORT_BY_AZ}</Dropdown.Item>
          <Dropdown.Item eventKey={SORT_BY_VALUE}>
            {SORT_BY_VALUE}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

class ChartHeader extends Component {
  constructor(props) {
    super(props);
    this.createKey = this.createKey.bind(this);
    this.isSelected = this.isSelected.bind(this);
  }

  createKey(location, mode) {
    return location + "_" + mode;
  }

  isSelected(location, mode) {
    return this.props.location === location && this.props.mode === mode;
  }

  render() {
    // The forwardRef is important!!
    // Dropdown needs access to the DOM node in order to position the Menu
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
      <h3
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
        id="chart-title"
      >
        {children}
        &nbsp;
        <FontAwesomeIcon icon={faCaretSquareDown} id="title-dropdown-icon" />
      </h3>
    ));

    let title = this.props.location;
    let subtitle = "";
    if (this.props.mode === DAILY_CHANGE_MODE) {
      title += " Daily Change in Case Count";
    } else if (this.props.mode === DAILY_CHANGE_ROLLING_MODE) {
      title += " Daily Change in Case Count";
      subtitle = "Rolling 7-Day";
    } else if (this.props.mode === CUM_COUNT_MODE) {
      title += " Cumulative Case Count";
    }

    if (this.props.scaleByPopulation) {
      if (subtitle.length > 0) {
        subtitle += ", Cases per 100k";
      } else {
        subtitle = "Cases per 100k";
      }
    }

    return (
      <div className="text-center" id="chart-header">
        <Dropdown
          id="title-dropdown"
          alignRight={true}
          onSelect={this.props.handleChange}
        >
          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
            {title}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              eventKey={this.createKey(US_LOCATION, DAILY_CHANGE_MODE)}
              id={
                this.isSelected(US_LOCATION, DAILY_CHANGE_MODE)
                  ? "selected"
                  : ""
              }
            >
              US Daily Change (Raw)
            </Dropdown.Item>
            <Dropdown.Item
              eventKey={this.createKey(US_LOCATION, DAILY_CHANGE_ROLLING_MODE)}
              id={
                this.isSelected(US_LOCATION, DAILY_CHANGE_ROLLING_MODE)
                  ? "selected"
                  : ""
              }
            >
              US Daily Change (Rolling 7d)
            </Dropdown.Item>
            <Dropdown.Item
              eventKey={this.createKey(US_LOCATION, CUM_COUNT_MODE)}
              id={
                this.isSelected(US_LOCATION, CUM_COUNT_MODE) ? "selected" : ""
              }
            >
              US Cumulative Case Count
            </Dropdown.Item>
            <Dropdown.Item
              eventKey={this.createKey(GLOBAL_LOCATION, DAILY_CHANGE_MODE)}
              id={
                this.isSelected(GLOBAL_LOCATION, DAILY_CHANGE_MODE)
                  ? "selected"
                  : ""
              }
            >
              Global Daily Change (Raw)
            </Dropdown.Item>
            <Dropdown.Item
              eventKey={this.createKey(
                GLOBAL_LOCATION,
                DAILY_CHANGE_ROLLING_MODE
              )}
              id={
                this.isSelected(GLOBAL_LOCATION, DAILY_CHANGE_ROLLING_MODE)
                  ? "selected"
                  : ""
              }
            >
              Global Daily Change (Rolling 7d)
            </Dropdown.Item>
            <Dropdown.Item
              eventKey={this.createKey(GLOBAL_LOCATION, CUM_COUNT_MODE)}
              id={
                this.isSelected(GLOBAL_LOCATION, CUM_COUNT_MODE)
                  ? "selected"
                  : ""
              }
            >
              Global Cumulative Case Count
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <h5 className="pageSubtitle">(Data as of March 10, 2023)</h5>        
        <span id="chart-subtitle">{subtitle}</span>
      </div>
    );
  }
}

class Chart extends Component {
  state = {
    dailyCounts: {
      [US_LOCATION]: [],
      [GLOBAL_LOCATION]: [],
      [US_LOCATION_SCALED]: [],
      [GLOBAL_LOCATION_SCALED]: [],
    },
    showAllCountries: false,
    scaleByPopulation: false,
  };

  constructor(props) {
    super(props);

    this.baseHighchartOptions = {
      chart: {
        height: "100%",
        type: "areaspline",
        zoomType: "x",
      },
      title: {
        floating: false,
        margin: 0,
        style: { fontSize: "11px" },
        widthAdjust: 0,
      },
      tooltip: {
        borderRadius: 3,
        padding: 5,
        style: { fontSize: "10px" },
        xDateFormat: '<span style="font-size: 8px">%b %d, %Y</span><br/>',
        valueDecimals: 0,
      },
      xAxis: {
        type: "datetime",
        visible: false,
      },
      yAxis: {
        endOnTick: false,
        title: {
          text: "Number of cases",
        },
        visible: false,
      },
      legend: {
        enabled: false,
      },
      series: [],
      credits: {
        enabled: false,
      },
      annotations: [],
      boost: {
        useGPUTranslations: true,
        seriesThreshold: 5
      }
    };

    this._updateDailyCounts = this._updateDailyCounts.bind(this);
    this.createHighchart = this.createHighchart.bind(this);
    this.copyObject = this.copyObject.bind(this);
    this.displayValueSorter = this.displayValueSorter.bind(this);
    this.getChartWidths = this.getChartWidths.bind(this);
    this.getDataId = this.getDataId.bind(this);
    this.handleShowCountriesChange = this.handleShowCountriesChange.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // copy a list or dict object
  copyObject(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  componentDidUpdate() {
    // reflow chart to fit container
    Highcharts.charts.forEach((chart) => {
      if (typeof chart !== "undefined") {
        chart.reflow();
      }
    });
    if (this.props.isLoading) {
      setTimeout(
        function () {
          this.props.turnOffLoading();
        }.bind(this),
        10
      );
    }
  }

  getDataId() {
    if (this.props.scaleByPopulation) {
      return this.props.location + SCALED_SUFFIX;
    } else {
      return this.props.location;
    }
  }

  handleShowCountriesChange() {
    // artifically set isLoading to true then false for better user experience
    this.props.turnOnLoading();
    setTimeout(
      function () {
        this.setState({ showAllCountries: true }, this.props.turnOffLoading);
      }.bind(this),
      10
    );
  }

  _updateDailyCounts(dataId, data, callback) {
    let newDailyCounts = {
      [US_LOCATION]: this.state.dailyCounts[US_LOCATION],
      [GLOBAL_LOCATION]: this.state.dailyCounts[GLOBAL_LOCATION],
      [US_LOCATION_SCALED]: this.state.dailyCounts[US_LOCATION_SCALED],
      [GLOBAL_LOCATION_SCALED]: this.state.dailyCounts[GLOBAL_LOCATION_SCALED],
    };
    newDailyCounts[dataId] = data;
    this.setState({ dailyCounts: newDailyCounts }, callback);
  }

  loadData() {
    let url = "/api/daily_case_counts?location=" + this.props.location;
    if (this.props.scaleByPopulation) {
      url = "/api/daily_case_counts_pop_scaled?location=" + this.props.location;
    }
    fetch(url)
      .then((res) => res.json())
      .then((resp) => {
        this._updateDailyCounts(
          this.getDataId(),
          resp["data"],
          this.props.turnOffLoading
        );
      })
      .catch(console.log);
  }

  getChartWidths() {
    let xlChartWidth;
    let lgChartWidth;
    let smChartWidth;
    if (this.props.regionFilter.size === 0) {
      xlChartWidth = 1;
      lgChartWidth = 2;
      smChartWidth = 3;
    } else if (this.props.regionFilter.size <= 3) {
      xlChartWidth = 4;
      lgChartWidth = 4;
      smChartWidth = 4;
    } else if (this.props.regionFilter.size === 4) {
      xlChartWidth = 3;
      lgChartWidth = 3;
      smChartWidth = 3;
    } else {
      xlChartWidth = 2;
      lgChartWidth = 2;
      smChartWidth = 3;
    }
    return {
      xlChartWidth: xlChartWidth,
      lgChartWidth: lgChartWidth,
      smChartWidth: smChartWidth,
    };
  }

  createHighchart(data) {
    let highchartsOptions = this.copyObject(this.baseHighchartOptions);

    let region = data["region"];
    if (
      this.props.regionFilter.size > 0 &&
      !this.props.regionFilter.has(region)
    ) {
      return undefined;
    }

    let seriesName; // series name for display
    if (
      this.props.mode === DAILY_CHANGE_MODE ||
      this.props.mode === DAILY_CHANGE_ROLLING_MODE
    ) {
      seriesName = "Change";
    } else if (this.props.mode === CUM_COUNT_MODE) {
      seriesName = "Count";
    }
    highchartsOptions["series"] = [
      {
        data: this.copyObject(data[this.props.mode]["data"]),
        name: seriesName,
      },
    ];
    let displayValue = data[this.props.mode]["displayValue"];
    let labelValue = displayValue.toLocaleString();
    if (this.props.scaleByPopulation) {
      if (this.props.mode !== CUM_COUNT_MODE) {
        labelValue = displayValue.toFixed(1).toLocaleString();
        highchartsOptions["tooltip"]["valueDecimals"] = 1;
      } else {
        labelValue = parseInt(displayValue.toFixed(0), 10).toLocaleString();
      }
    }
    if (this.props.showLabelValues) {
      highchartsOptions["annotations"].push({
        labels: [
          {
            align: "left",
            point: {
              x: 1,
              y: 29,
            },
            text: labelValue,
            style: {
              fontSize: "9px",
            },
            padding: 1,
            overflow: "none",
            shape: "rect",
          },
        ],
      });
    }
    highchartsOptions["title"]["text"] = region;

    // compute default chart width based on the number of states to show
    let chartWidths = this.getChartWidths();

    return (
      <Col
        xl={chartWidths["xlChartWidth"]}
        lg={chartWidths["lgChartWidth"]}
        sm={chartWidths["smChartWidth"]}
        xs="6"
        key={region + "_col"}
        className="chartCol"
      >
        <HighchartsReact
          key={region + "_chart"}
          highcharts={Highcharts}
          options={highchartsOptions}
          allowChartUpdate={true}
        />
      </Col>
    );
  }

  displayValueSorter(first, second) {
    return (
      second[this.props.mode]["displayValue"] -
      first[this.props.mode]["displayValue"]
    );
  }

  render() {
    let loadingIcon = (
      <Row className="chartArea">
        <FontAwesomeIcon icon={faSpinner} id="loading-icon" spin />
      </Row>
    );

    let dataId = this.getDataId();

    if (this.state.dailyCounts[dataId].length === 0) {
      // load data
      this.loadData();
      return loadingIcon;
    }

    if (this.props.isLoading) {
      return loadingIcon;
    }

    let dataToRender = this.state.dailyCounts[dataId].concat(); // get a copy, by default sorted a-z
    if (this.props.sortBy === SORT_BY_VALUE) {
      dataToRender = dataToRender.sort(this.displayValueSorter);
    }
    let MAX_PLOTS = 59; // initially only show 59 plots at once
    let plotsHidden = false; // where some plots hidden
    if (dataToRender.length > MAX_PLOTS && !this.state.showAllCountries) {
      dataToRender = dataToRender.slice(0, MAX_PLOTS);
      plotsHidden = true;
    }
    let charts = dataToRender.map(this.createHighchart);
    if (plotsHidden) {
      let chartWidths = this.getChartWidths();
      charts.push(
        <Col
          xl={chartWidths["xlChartWidth"]}
          lg={chartWidths["lgChartWidth"]}
          sm={chartWidths["smChartWidth"]}
          xs="6"
          key={"showMoreData"}
          className="chartCol align-self-center text-center"
        >
          <Button
            variant="secondary"
            onClick={this.handleShowCountriesChange}
            id="show-all-countries-button"
          >
            show all
          </Button>
        </Col>
      );
    }
    return <Row className="chartArea">{charts}</Row>;
  }
}

class LabelValueSwitch extends Component {
  render() {
    let label;
    if (
      this.props.mode === DAILY_CHANGE_MODE ||
      this.props.mode === DAILY_CHANGE_ROLLING_MODE
    ) {
      label = "Show current seven-day average";
    } else if (this.props.mode === CUM_COUNT_MODE) {
      label = "Show current case count";
    }
    return (
      <Form className="form-check-inline">
        <Form.Check
          type="switch"
          className="form-control-sm"
          id="delta-switch"
          label={label}
          checked={this.props.value}
          onChange={this.props.handleChange}
        />
      </Form>
    );
  }
}

class ScaleByPopulationSwitch extends Component {
  render() {
    let label = "Scale by population";
    return (
      <Form className="form-check-inline">
        <Form.Check
          type="switch"
          className="form-control-sm"
          id="scale-by-pop-switch"
          label={label}
          checked={this.props.value}
          onChange={this.props.handleChange}
        />
      </Form>
    );
  }
}

class RegionFilter extends Component {
  state = {
    autocompleteValues: {
      [US_LOCATION]: [],
      [GLOBAL_LOCATION]: [],
    },
  };

  componentDidMount() {
    fetch("/api/region_names")
      .then((res) => res.json())
      .then((data) => {
        this.setState({ autocompleteValues: data });
      })
      .catch(console.log);
  }

  render() {
    let placeholder;
    if (this.props.location === US_LOCATION) {
      placeholder = "Select a state";
    } else if (this.props.location === GLOBAL_LOCATION) {
      placeholder = "Select a country";
    }
    // TODO: have typeahead check matches first
    // TODO: have America also register US
    let autocompleteValues = this.state.autocompleteValues[this.props.location];
    return (
      <Typeahead
        id="region-filters"
        labelKey="name"
        multiple
        onChange={this.props.handleChange}
        options={autocompleteValues}
        placeholder={placeholder}
        selected={this.props.regionFilter}
      />
    );
  }
}

export { ChartArea };



// WEBPACK FOOTER //
// ./src/_case_counts.js